const useAnotherGaEvents = () => {
  function trackLike(contentTitle: string) {
    window.gtag("event", "like_clicked", {
      content_title: contentTitle,
      engagement_type: "like",
    });
  }

  function trackBookmark(contentTitle: string) {
    window.gtag("event", "bookmark_added", {
      content_title: contentTitle,
      engagement_type: "bookmark",
    });
  }

  function trackShare(contentTitle: string) {
    window.gtag("event", "content_shared", {
      content_title: contentTitle,
      engagement_type: "share",
    });
  }

  function trackSearch(searchTerm: string) {
    window.gtag("event", "search_performed", {
      search_term: searchTerm,
      engagement_type: "search",
    });
  }

  function trackMonthlyPurchase(subscriptionPrice: number, currency = "USD") {
    window.gtag("event", "purchase_monthly", {
      transaction_id: "monthly_" + Date.now(),
      value: subscriptionPrice,
      currency: currency,
      items: [
        {
          item_id: "monthly_subscription",
          item_name: "Monthly Subscription",
          item_category: "subscription",
          item_variant: "monthly",
          price: subscriptionPrice,
          quantity: 1,
        },
      ],
    });
  }

  function trackYearlyPurchase(subscriptionPrice: number, currency = "USD") {
    window.gtag("event", "purchase_yearly", {
      transaction_id: "yearly_" + Date.now(),
      value: subscriptionPrice,
      currency: currency,
      items: [
        {
          item_id: "yearly_subscription",
          item_name: "Yearly Subscription",
          item_category: "subscription",
          item_variant: "yearly",
          price: subscriptionPrice,
          quantity: 1,
        },
      ],
    });
  }

  return {
    trackLike,
    trackBookmark,
    trackShare,
    trackSearch,
    trackMonthlyPurchase,
    trackYearlyPurchase,
  };
};

export default useAnotherGaEvents;
